import { BoundedContent, Box, Link, P, Typography } from '@vp/swan';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { __ } from '@99designs/i18n';
import Ghost from '../NotFound/Ghost.png';

export function InternalErrorWrapper({
    useImg,
    children,
}: {
    useImg?: boolean;
    children: React.ReactNode;
}) {
    return (
        <BoundedContent>
            <Box marginTop={10} marginBottom={'7'} textAlign="center">
                <Box marginTop={8}>
                    {useImg ? (
                        <img alt="ghost" src={Ghost} width={128} height={128} />
                    ) : (
                        <Image alt="ghost" src={Ghost} width={128} height={128} />
                    )}
                </Box>
                <Box marginTop={8}>{children}</Box>
            </Box>
        </BoundedContent>
    );
}

export function InternalError() {
    const helpCenterLink = 'https://support.99designs.com/hc/en-us'; // Need to get this localised
    const router = useRouter();
    const { briefId } = router.query;

    return (
        <InternalErrorWrapper>
            <Box marginTop={8}>
                <Typography fontSize="x3large" fontWeight="bold">
                    {__('Boo. Something went wrong on our end')}
                </Typography>
            </Box>
            <Box marginTop={'7'}>
                <Link href={helpCenterLink}>
                    {__('Please reach out to 99designs by Vista Customer Support for help.')}
                </Link>
            </Box>
            {briefId && (
                <Box marginTop={'3'} marginBottom={'7'}>
                    <P>
                        {__('Brief ID:')}&nbsp;
                        {briefId as string}
                    </P>
                </Box>
            )}
        </InternalErrorWrapper>
    );
}
